<template>
  <div>
    <div style="display:block;" v-if="!loading">
      <el-pagination 
        v-if="list.length > 0"
        @current-change="pageChange" 
        :current-page="currentPage" 
        :page-size="pageSize" 
        :page-sizes="[40]" 
        layout="total, sizes, pager" 
        :total="total" 
        style="text-align:right;">
      </el-pagination>
    </div>
    <el-row :gutter="10" v-if="!loading">
      <el-col :span="12" v-for="item in list" :key="item.id" style="margin-top:10px;">
        <div id="company-list">
          <div :class="['title', item.name_hide === '1' ? 'hide-name' : '']">
            <router-link style="float:left;" :to="'/customer/company/' + item.id" v-if="user.role_id < 3 || item.name_hide === '0'">{{ item.name }}</router-link>
            <span style="float:left;" v-if="item.last_po_inv_time && (user.role_id < 3 || item.name_hide === '0')">
              <router-link :to="'/customer/company/' + item.id" style="color:red">(PO&amp;PI)</router-link>
            </span>
            <div style="float:right;margin-right:6px;font-weight: normal;">{{ item.id }}</div>
            <div style="clear:both;"></div>
          </div>
          <div class="subtitle">
            {{ item.abbreviation }}<br/>
          </div>
          <div class="contact">
            <el-row style="margin-top:10px;">
              <el-col :span="12">
                Country:&nbsp;{{ item.country }}
              </el-col>
              <el-col :span="12">
                Customer Source:&nbsp;{{ item.source }}
              </el-col>
            </el-row>
            <el-row style="margin-top:10px;">
              <el-col :span="8" style="color:#2b3bff;" v-if="item.sales2_name">
                <br/>
                1.{{ item.sales_name }}&nbsp;&nbsp;&nbsp;2.{{ item.sales2_name }}
              </el-col>
              <el-col :span="8" style="color:#2b3bff;" v-else>
                <br/>
                1.{{ item.sales_name }}
              </el-col>
              <el-col :span="16" style="text-align:right;">
                Create by {{ item.create_oper_name }},&nbsp;{{ item.create_time.substr(0, 10) }}<br/>
                Modified by {{ item.update_oper_name }},&nbsp;{{ item.update_time.substr(0, 10)  }} 
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <div v-if="loading" style="text-align:center;font-size:28px;padding:100px 0;">
      <i class="el-icon-loading"></i>
    </div>
    <div v-if="list.length === 0 && !loading" style="width:100%;text-align:center;margin-top:100px;">
      没有找到相关客户
    </div>
  </div>
</template>

<script>
export default {
  name: 'customer-company-list',
  props: {
    params: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      list: [],
      total: 0,
      loading: false,
      pageSize: 40,
      currentPage: 1
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  watch: {
    'params' () {
      this.currentPage = 1
      this.fetchList()
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    fetchList () {
      let params = { ...this.params }
      if (this.pageSize > 0) {
        params.start = (this.currentPage - 1) * this.pageSize
        params.limit = this.pageSize
      }
      let url = params.order_by === 'desc' ? '/dbapi/company_list' : '/dbapi/company_list_asc'
      this.loading = true
      this.$http.get(url, { params }).then(data => {
        this.loading = false
        this.list = data.list
        this.total = data.total
      }).catch(() => this.loading = false)
    },
    pageChange (val) {
      this.currentPage = val
      this.fetchList()
    }
  }
}
</script>

<style lang="scss">
#company-list {
  border: 1px solid #CCCCCC;
  .title {
    background-color: #e6ddff;
    color: #000;
    padding: 2px;
    height: 22px;
    line-height: 22px;
    font-weight: bold;
  }
  .subtitle {
    background-color: #e6ddff;
    color: #000;
    padding: 2px;
    height: 20px;
    line-height: 20px;
  }
  .title a {
    color: #000;
  }
  .title a:hover {
    color: #f28500;
  }
  .contact {
    background-color: #EBF5FB;
    padding: 2px;
    font-size: 12px;
  }
  .hide-name {
    background-color: yellow;
  }
}
</style>
